import React from "react";
import { useTranslation } from "react-i18next";

const Responsibility = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`responsibility.${key}`);
  const responsibilityText = [
    "As the responsible Casino, we adopt a series of safer entertainment processes and methods, which allows players to have a comfortable and pleasant experience when gambling. Hope all of you can carefully adjust your mentality,do not get addicted to affecting personal economics, family and your career etc.",
    "The small wager chief use for delight. 911win is committed to improving staffs and customers' knowledge in injury perception of gambling-related issues, helping customers to understand employees' emotional behavior at any time, and to adjust their entertainment mentality. Also, they need to live and work normally, with the ability to make rational judgments.",
    "Gambling and entertainment should pay attention to:",
    "1. Don't think of gambling as a tool to make money. Not just casinos, but all forms of gambling have the same rules - many losers, few winners, and only a few have a chance to hit the jackpot. Almost anyone with a gambling problem has high hopes for gambling that they are the ones who will hit the jackpot.",
    "2. Gambling within your means. Do not carry a credit card or ATM card when you gamble,never borrow to gamble, just use your idle funds to gamble. Before engaging in gambling, determine how much you can afford to lose, and if you have already lost the money, exit immediately to avoid consecutive losses.",
    "3. Set a time limit. Rationalize your time and effort in gambling and determine how much time you can dedicate to gambling. If you reach this time limit, stop gambling. Never chase losses and try to win back your lost money by going beyond your load limit, which often results in bigger losses.",
    "4. Don't gamble while drunk or upset. It's hard to make good gambling decisions when you're feeling down or depressed.",
    "If you have any questions, 911win provides 24/7 consulting service to solve any of your requests.",
  ];
  return (
    <section className="w-full mt-[10px] rounded-[5] px-[10px] py-[16px] bg-base-light-white dark:bg-base-light-dark relative mb-[15px] flex flex-col items-center gap-[15px] font-medium">
      <h1 className="my-2 !mt-2 text-base-light-dark dark:text-base-light-white text-xl md:text-3xl font-semibold">
        {i18n("Gaming Responsibility")}
      </h1>
      <div className="text-base-deep-dark w-full dark:text-base-light-white">
        <div className="p-8 font-normal">
          {responsibilityText.map((text, index) => (
            <div key={index} className="mb-6 flex flex-col">
              {i18n(text)}
            </div>
          ))}
          　
        </div>
      </div>
    </section>
  );
};

export default Responsibility;
